<!--
component: BrowseBuildingOwner
author: Ken Nakamura
description: 建築計画概要書（第一面 建築主）
-->
<template>
  <section>
    <div v-show="startIndex==0 && endIndex>0" class="gaiyo-row">
      <hr>
      <div class="gaiyo-major-title">
      【1.建築主】
      </div>
    </div>
    <div v-for="(owner, index) in owners" :key="index">
      <div v-show="index>=startIndex && index<endIndex" class="person-block">
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ｲ.氏名のﾌﾘｶﾞﾅ】</div>
        <div class="gaiyo-element left-45 furigana">{{owner.bldR_NAME_KANA}}</div>
        <div v-for="(n,index) in wordwrap(owner.bldR_NAME_KANA,80)" :key="`bldr-kana-${index}`">
          <br v-show="index>0"></div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾛ.氏名】</div>
        <div class="gaiyo-element left-45">
          {{owner.bldR_NAME_KANJI}}
        </div>
        <div v-for="(n,index) in wordwrap(owner.bldR_NAME_KANJI,40)" :key="`bldr-name-${index}`">
          <br v-show="index>0"></div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾊ.郵便番号】</div>
        <div class="gaiyo-element left-45">{{owner.bldR_POSTNO}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾆ.住所】</div>
        <div class="gaiyo-element left-45">{{owner.bldR_ADDR}}</div>
        <div v-for="(n,index) in wordwrap(owner.bldR_ADDR,40)" :key="`bldr-addr-${index}`">
          <br v-show="index>0"></div>
      </div>
      </div>
    </div>
    <!--
    <canvas :id="canvasId">
    </canvas>
    -->
  </section>
</template>

<script>
export default {
  props: {
    canvasId: {
      type: String,
      default: 'canvas',
    },
    owners: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: () => 0,
    },
    endIndex: {
      type: Number,
      default: () => 99,
    },
  },
  mounted() {
    //this.drawtest();
  },
  computed: {
  },
  methods: {
    drawtest() {
      const canvas = document.getElementById(this.canvasId);
      const ctx = canvas.getContext('2d');
      ctx.strokeStyle="rgb(0,0,0)";
      ctx.fillStyle="rgb(0,0,0)";
      const h = 190;
      const w = 276;
      const resolution = 300;
      const pixPerMM = resolution / 25.4;
      canvas.width = w * pixPerMM;
      canvas.height = h * pixPerMM;
      canvas.style.width = `${w}mm`;
      canvas.style.height = `${h}mm`;
      ctx.beginPath();
      ctx.moveTo(10 * pixPerMM, 10 * pixPerMM);
      ctx.lineTo(180 * pixPerMM, 10 * pixPerMM);
      ctx.closePath();
      ctx.stroke();
      ctx.font = `600 ${4.8*pixPerMM}px "ＭＳ 明朝"`;
      ctx.fillText('【1.建築主】', 10 * pixPerMM, 20 * pixPerMM);
      ctx.fillText('【ｲ.氏名のﾌﾘｶﾞﾅ】', 14 * pixPerMM, 26 * pixPerMM);
    },
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/gaiyo.css";
</style>